import { Point } from '@ng-cloud/badger-core/models/interfaces/point';
import { FabricObject, Rect } from 'fabric';
import { TopStock } from '../../models/top-stock';

import { MapObject } from './map-object';

export class TopStockObject extends MapObject {
  static DEFAULT_STROKE_WIDTH = 3;

  static DEFAULT_COLOR = '#FFFFFF90';
  static HIGHLIGHTED_COLOR = '#C71BF1';

  strokeWidth = TopStockObject.DEFAULT_STROKE_WIDTH;

  defaultOptions: any = {
    selectable: false,
    evented: true,
    lockScalingFlip: true,
    fill: 'transparent',
    stroke: TopStockObject.DEFAULT_COLOR,
    opacity: 1,
    lockMovementX: true,
    lockMovementY: true,
    hasControls: false,
    hoverCursor: 'pointer'
  };

  rect: Rect;

  constructor(public topStock: TopStock, private points: Point[], config?: any) {
    super(config);

    const scaleFactor = config.scaleFactor ? config.scaleFactor : 1;
    this.strokeWidth = TopStockObject.DEFAULT_STROKE_WIDTH * scaleFactor;

    Object.assign(this.defaultOptions, { strokeWidth: this.strokeWidth });
  }

  protected build(): FabricObject {
    this.rect = new Rect(this.getOptions());
    this.rect.set({ data: this.topStock });

    return this.rect;
  }

  protected getInstanceOptions(): any {
    return {
      width: Math.abs(this.points[0].x - this.points[1].x) - this.strokeWidth,
      height: Math.abs(this.points[0].y - this.points[2].y) - this.strokeWidth,
      left: this.points[0].x,
      top: this.points[2].y
    };
  }

  setHighlighted(highlighted: boolean) {
    this.getFabric().set({
      stroke: highlighted ? TopStockObject.HIGHLIGHTED_COLOR : TopStockObject.DEFAULT_COLOR,
      strokeWidth: this.strokeWidth
    });
  }
}
